import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react"
import { faCircleArrowLeft } from "@fortawesome/free-solid-svg-icons/faCircleArrowLeft";
import { faSquare } from "@fortawesome/free-solid-svg-icons/faSquare";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons/faCheckCircle";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons/faCircleXmark";
import { InputMascara } from "app/components/inputs/InputMascara";
const estilos = require('./disponibilidade-capacidade-de-carga.module.scss').default
const estiloFormulario = require('../../../estilos/formulario.module.scss').default
const estiloBotoes = require('../../../estilos/botoes.module.scss').default
import clsx from 'clsx'
import Legenda from "app/components/itens-orcamento/legenda/Legenda";
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css'
import { DataFormatoEN } from "app/types/DataFormatoEN";
import { DataFormatoPT } from "app/types/DataFormatoPT";
import globalMU from "globalMU";
import { DadosPorItem } from "./DadosPorItem";
import { DisponibilidadeCapacidadeCargaItemOrcamento } from "./DisponibilidadeCapacidadeCargaPorItemOrcamento";
import { IdentificadorItem } from "app/types/IdentificadorItem";
import * as R from 'ramda'
import { Dict } from "app/utils/Dict";
import { ChaveAgrupamento } from "./ChaveAgrupamento";
import { DisponibilidadeCapacidadeCargaPorItensAgrupados } from "./DisponibilidadeCapacidadeCargaPorItensAgrupados";
import { ValorAgrupamento } from "./ValorAgrupamento";
import { Separador } from "app/components/separador/Separador";
import { TooltipMU } from "app/components/tooltip/TooltipMU";

export type TipoExibicao = "ITEM_A_ITEM" | "AGRUPADO"

export type DisponibilidadeCapacidadeDeCargaProps = {
    itens: DadosPorItem[]
    roteiro: string

    onConfirmarNovasDatas: (datasPorItem: {
        [key: IdentificadorItem]: {
            novaDataPrevista: DataFormatoPT
            filial: string
        }
    }) => void

    onAtualizarCalendarioPorItemOrcamento: (dataReferencia: Date) => void
    onAtualizarCalendarioPorItensAgrupados: (dataReferencia: Date) => void

    tipoExibicao: TipoExibicao
}



export const DisponibilidadeCapacidadeDeCarga = (props: DisponibilidadeCapacidadeDeCargaProps) => {

    const [itemSelecionado, setItemSelecionado] = useState<DadosPorItem>(null)
    const [executarScroll, setExecutarScroll] = useState<boolean>(true)

    const [datasPorItem, setDatasPorItem] = useState<{
        [key: IdentificadorItem]: {
            novaDataPrevista: DataFormatoPT
            filial: string
        }
    }>({})

    const [itensAgrupados, setItensAgrupados] = useState<Dict<ChaveAgrupamento, ValorAgrupamento>>(new Dict<ChaveAgrupamento, ValorAgrupamento>())

    const [chaveAgrupamentoSelecionadaStr, setChaveAgrupamentoSelecionadaStr] = useState<string>("")
    const [tipoExibicao, setTipoExibicao] = useState<TipoExibicao>(props.tipoExibicao)

    const adicionarClasse_no_global_button_ABotoesDeNavegacaoDosCalendarios = () => {
        for (let calendario of (document.getElementsByClassName("react-calendar__navigation") ?? [])) {
            for (let botao of (calendario.getElementsByTagName("button") ?? [])) {
                botao.classList.add("no-global-button")
            }
        }

    }

    const setarDataPrevistaParaItem = (identificadorItem: number, data: DataFormatoPT) => {
        setDatasPorItem(datasPorItem => {

            const filial = props.itens.find(i => i.identificador == identificadorItem).filial

            datasPorItem[identificadorItem] = {
                novaDataPrevista: data,
                filial
            }

            return datasPorItem
        })
    }

    const obterDadosCalendariosPorItemOrcamento = () => {
        return (props.itens ?? []).map(item => ({
            identificador: item.identificador,
            calendario: <DisponibilidadeCapacidadeCargaItemOrcamento
                key={`calendario-item-${item.identificador}`}
                dadosPorItem={item}
                onNovaDataSelecionada={data => setarDataPrevistaParaItem(item.identificador, data)}
                onAtualizarCalendario={dataReferencia => props.onAtualizarCalendarioPorItemOrcamento(dataReferencia)}
                novaDataPrevista={datasPorItem[item.identificador]?.novaDataPrevista ?? ""}

            />
        }))
    }

    const obterDadosCalendariosPorItensAgrupados = () => {
        return itensAgrupados.keys().map(chaveAgrupamento => ({
            chaveAgrupamento,
            calendario: <DisponibilidadeCapacidadeCargaPorItensAgrupados
                key={itensAgrupados.keysValues().join("-")}
                dadosItensAgrupados={{
                    chaveAgrupamento,
                    identificadoresItens: itensAgrupados.get(chaveAgrupamento).identificadoresItens,
                    datas: itensAgrupados.get(chaveAgrupamento).datas
                }}
                onNovaDataSelecionada={data => {
                    itensAgrupados.get(chaveAgrupamento).identificadoresItens.forEach(identificadorItem => setarDataPrevistaParaItem(identificadorItem, data))
                }}

                onAtualizarCalendario={dataReferencia => props.onAtualizarCalendarioPorItensAgrupados(dataReferencia)}

            />
        }))
    }

    const [calendariosPorItemOrcamento, setCalendariosPorItemOrcamento] = useState(obterDadosCalendariosPorItemOrcamento())
    const [calendariosPorItensAgrupados, setCalendariosPorItensAgrupados] = useState(obterDadosCalendariosPorItensAgrupados())



    const exibicaoItemOrcamento = (item: DadosPorItem) => {

        const dadosIcone = {
            cor: item.situacao == "CAPACIDADE_CARGA_OK" ? "green" : "red",
            icone: item.situacao == "CAPACIDADE_CARGA_OK" ? faCheckCircle : faCircleXmark
        }

        return <div
            id="DisponibilidadeCapacidadeDeCarga_itemOrcamento"
            title="Clique para selecionar o item e alterar a nova data"
            key={item.identificador}
            onClick={() =>{

                setItemSelecionado(item)}}
            className={clsx("_cursor-pointer _flex _flex-row _gap-4 _p-4", item.identificador == itemSelecionado?.identificador ? estilos.itemSelecionado : null)}>
            <FontAwesomeIcon
                className={"material-icons"}
                color={dadosIcone.cor}
                icon={dadosIcone.icone}
            />
            <div className="_flex _flex-col">
                <span className="_block _text-lg">
                    {item.descricao}
                </span>
                <span className="_block _text-sm">
                    {item.identificacaoProduto == "CODIGO" ? "Código" : "Referência"} {item.codigoOuReferencia}
                </span>
                <span className="_block _text-sm">
                    Filial <b>{item.filial}</b> / {item.dataPrevista ? `Data Prevista: ${item.dataPrevista}` : `Data Marcada: ${item.dataMarcada}`}
                </span>


                {globalMU.isNotNullOrEmpty(item.tipoFrete?.nome) &&
                    <span className="_block _text-sm">
                        Tipo de Frete: {item.tipoFrete.nome}
                    </span>}
            </div>
        </div>
    }

    const exibicaoItensAgrupados = (chave: ChaveAgrupamento) => {
        const existeAlgumItemComSituacaoDiferenteDeOk = () => {
            return itensAgrupados.get(chave).identificadoresItens.some(identificadorItem => props.itens.find(i => i.identificador == identificadorItem)?.situacao != "CAPACIDADE_CARGA_OK")
        }

        const dadosIcone = {
            cor: existeAlgumItemComSituacaoDiferenteDeOk() ? "red" : "green",
            icone: existeAlgumItemComSituacaoDiferenteDeOk() ? faCircleXmark : faCheckCircle
        }

        return <div
            title="Clique para selecionar o item e alterar a nova data"
            key={JSON.stringify(chave)}
            className={clsx("_cursor-pointer _flex _flex-row _gap-4 _p-4 ", itensAgrupados.hashFunction(chave) == chaveAgrupamentoSelecionadaStr ? estilos.itemSelecionado : null)}
            onClick={() => setChaveAgrupamentoSelecionadaStr(itensAgrupados.hashFunction(chave))}
        >
            <FontAwesomeIcon
                className={"material-icons"}
                color={dadosIcone.cor}
                icon={dadosIcone.icone}
            />
            <div className="_flex _flex-col"
                id="DisponibilidadeCapacidadeDeCarga_dadosAgrupados">
                <div>
                    Filial <b>{chave.codigoFilial}</b> / Data Prevista <b>{chave.dataPrevista}</b>
                </div>

                <div>
                    {globalMU.isNotNullOrEmpty(chave.tipoFrete?.nome) && <>Tipo de Frete: {chave.tipoFrete?.nome}</>}
                </div>

                <div>
                    Qtde. de itens: {(itensAgrupados.get(chave)?.identificadoresItens ?? []).length}
                </div>
            </div>

        </div>
    }

    const agruparItens = () => {
        const itensAgrupados_ = props.itens.reduce((dict, item) => {

            const chave: ChaveAgrupamento = {
                codigoFilial: item.filial,
                dataPrevista: item.dataPrevista,
                tipoFrete: {
                    id: item.tipoFrete?.id,
                    nome: item.tipoFrete?.nome

                }

            }

            if (dict.has(chave)) {
                dict.get(chave).identificadoresItens.push(item.identificador)
                dict.get(chave).datas = item.datas
            } else {
                dict.set(chave, {
                    identificadoresItens: [item.identificador],
                    datas: item.datas
                })
            }

            return dict

        }, new Dict<ChaveAgrupamento, ValorAgrupamento>())

        setItensAgrupados(itensAgrupados_)
    }

    const ordenarItens = (item1: DadosPorItem, item2: DadosPorItem) => {
        return item1.situacao == "CAPACIDADE_CARGA_OK" ? 1 : -1
    }

    const botaoConfirmarNovasDatas = <div>
        <TooltipMU title="Clique aqui para confirmar as novas datas selecionadas para a carga e prosseguir para finalizar o orçamento" enterDelay={0}>
        <button className={clsx("no-global-button", estiloBotoes.botaoPrimario)}
            id="DisponibilidadeCapacidadeDeCarga_botaoConfirmarNovasDatas"
            onClick={() => props.onConfirmarNovasDatas(datasPorItem)}>
            Confirmar Novas Datas
        </button>
        </TooltipMU>
    </div>

    const listaItens = <div className="_flex _flex-col _gap-y-4"
        id="DisponibilidadeCapacidadeDeCarga_listaItens"
        style={{
            /*
            height: '500px',
            */
            minHeight: '100px',
            maxHeight: '500px',
            overflowY: 'scroll'
        }}>
        {tipoExibicao == "ITEM_A_ITEM" && <>
            {props.itens.map(exibicaoItemOrcamento)}
        </>}

        {tipoExibicao == "AGRUPADO" && <>
            {itensAgrupados.keys().map(exibicaoItensAgrupados)}
        </>}
    </div>

    const exibicaoCalendarioPorItemOrcamento = <div className="_col-span-2" id="DisponibilidadeCapacidadeDeCarga_exibicaoCalendarioPorItemOrcamento">
        {calendariosPorItemOrcamento.map(item => <div key={item.identificador} className={item.identificador == itemSelecionado?.identificador ? "_block" : "_hidden"}>
            {item.calendario}
        </div>)}
    </div>

    const exibicaoCalendarioPorItensAgrupados = <div className="_col-span-2" id="DisponibilidadeCapacidadeDeCarga_exibicaoCalendarioPorItensAgrupados">
        {calendariosPorItensAgrupados.map(item => <div key={itensAgrupados.hashFunction(item.chaveAgrupamento)} className={itensAgrupados.hashFunction(item.chaveAgrupamento) == chaveAgrupamentoSelecionadaStr ? "_block" : "_hidden"}>
            {item.calendario}
        </div>)}
    </div>

    const selectExibirComo = <div className={estiloFormulario.formulario}>
        
        <label>Exibir como</label>
        <TooltipMU title="Escolha se quer por Item a Item ou Agrupado" enterDelay={0}>
        <select value={(tipoExibicao) ?? ""}
            id="DisponibilidadeCapacidadeDeCarga_selectExibirComo"
            onChange={e => setTipoExibicao(e.target.value as TipoExibicao)}>
            <option value="ITEM_A_ITEM">Item a item</option>
            <option value="AGRUPADO">Agrupado</option>
        </select>
        </TooltipMU>
    </div>

    useEffect(() => {
        adicionarClasse_no_global_button_ABotoesDeNavegacaoDosCalendarios()
    }, [calendariosPorItemOrcamento, calendariosPorItensAgrupados])

    useEffect(() => {
        setCalendariosPorItemOrcamento(obterDadosCalendariosPorItemOrcamento())

        agruparItens()
    }, [props.itens])

    useEffect(() => {
        if (itemSelecionado !== null && executarScroll) {
            const objeto$ = $("#DisponibilidadeCapacidadeDeCarga_DivPrincipal")
            if (objeto$ != null)
                $("html, body").animate({ scrollTop: objeto$.offset().top}, 500);

            setExecutarScroll(false)
        }
    }, [itemSelecionado])

    useEffect(() => {
        setCalendariosPorItensAgrupados(obterDadosCalendariosPorItensAgrupados())
    }, [itensAgrupados])

    useEffect(() => {
        adicionarClasse_no_global_button_ABotoesDeNavegacaoDosCalendarios()
    }, [tipoExibicao])

    return <div 
        className="_flex _flex-col _gap-4"
        id="DisponibilidadeCapacidadeDeCarga_DivPrincipal"
    >
        <Separador />
        <h3 id="DisponibilidadeCapacidadeDeCarga_titulo"
        >Capacidade de Carga</h3>
{/*         
        {botaoConfirmarNovasDatas} 
        */}

        {selectExibirComo}

        <div className="_grid _grid-cols-3">

            {listaItens}

            {tipoExibicao == "ITEM_A_ITEM" && exibicaoCalendarioPorItemOrcamento}

            {tipoExibicao == "AGRUPADO" && exibicaoCalendarioPorItensAgrupados}

        </div>

        {botaoConfirmarNovasDatas} 
    </div>
}